// extracted by mini-css-extract-plugin
export default {"grid-container":"CardSlider_grid-container__0gkN5"};